// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3RsUX","question":"Question_question__F-gOF","description":"Question_description__16J_d"};